import { useCallback } from "react"
import { Link, useLocation } from "react-router-dom"

import useCollection from "areas/collection/hoc/use-collection"
import Button from "components/ui/button"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "components/ui/carousel"
import Image from "components/ui/image"
import { trackSuperFiltersEvent } from "helpers/collection"
import { getImgSrcSet } from "helpers/image"

const SuperFilters = () => {
  const location = useLocation()
  const { data: { super_filters: superFilters } = {} } = useCollection()

  const sanitizeLinks = useCallback(
    (url) => {
      if (!url) return null

      if (url.startsWith("?")) {
        return `${location.pathname}${url}`
      } else if (!url.startsWith("http") && !url.startsWith("/")) {
        return `/${url}`
      }

      return url
    },
    [location.pathname]
  )

  if (!superFilters) return null

  if (superFilters.type === "carousel") {
    return (
      <Carousel
        aria-label="Quick Filters"
        className="tablet:mx-0 -mx-16"
        disableSkip
        opts={{
          loop: false,
          slidesToScroll: "auto",
        }}
        role="navigation"
      >
        <CarouselContent className="tablet:px-0 gap-8 px-16">
          {superFilters.links.map((filter, index) => (
            <CarouselItem
              aria-roledescription={undefined}
              className="tablet:basis-130 basis-1/4"
              key={`super-filters-${filter.name}-${index}}`}
              role={undefined}
            >
              <Link
                className="block"
                data-lc="super-filters"
                onClick={() =>
                  trackSuperFiltersEvent(location.pathname, filter.url)
                }
                to={sanitizeLinks(filter.url)}
              >
                {filter.image && (
                  <Image
                    alt=""
                    className="h-auto w-full"
                    fallback={filter.image.fallback}
                    height={filter.image.height}
                    srcSet={getImgSrcSet(filter.image.src, filter.image.width)}
                    width={filter.image.width}
                  />
                )}
                <span className="text-13 mt-8 font-semibold">
                  {filter.name}
                </span>
              </Link>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="tablet:inline-flex" />
        <CarouselNext className="tablet:inline-flex" />
      </Carousel>
    )
  }

  return (
    <nav
      aria-label="Quick Filters"
      className="no-scrollbar desktop:flex-wrap desktop:justify-start desktop:overflow-x-auto desktop:overflow-y-auto desktop:gap-x-10 flex gap-x-6 gap-y-10 overflow-x-scroll whitespace-nowrap"
    >
      {superFilters.links.map((filter, index) => (
        <Button
          asChild
          className="border-grey-20 desktop:text-18 leading-25 inline-flex items-center rounded border px-20 font-bold focus-visible:-outline-offset-2"
          key={`super-filters-${filter.name}-${index}}`}
          size="sm"
          variant="tertiary"
        >
          <Link
            data-lc="super-filters"
            onClick={() =>
              trackSuperFiltersEvent(location.pathname, filter.url)
            }
            to={sanitizeLinks(filter.url)}
          >
            {filter.name}
          </Link>
        </Button>
      ))}
    </nav>
  )
}

export default SuperFilters
